<template>
  <div class="form-group"
    :class="{'is-invalid-group':error || errorMessage}"
  >

    <label class="form-control-label" :for="name">{{ label }}</label>

    <div class="input-group input-group-merge">
      <div class="input-group-prepend" v-if="icon">
        <span class="input-group-text">
          <feather :type="icon" class="icon-dual"></feather>
        </span>
      </div>

      <input
        :name="name"
        :type="type"
        autocomplete="autocomplete"
        class="form-control"
        :class="{ 'is-invalid': error || errorMessage, 'is-valid': !error && !errorMessage && isBlur }"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
        @blur="onBlur"
        :value="value"
        :readonly="readonly"
        :disabled="disabled"
      />
    </div>
    <div class="invalid-feedback" v-if="errorMessage">
      {{ errorMessage }}
    </div>
    <div class="invalid-feedback" v-else-if="error">
      Please provide a valid {{ name || label || 'input' }}
    </div>
    <div class="text-success" v-else-if="!error && !errorMessage && isBlur">
      Looks good!
    </div>
    <div class="text-muted" v-if="help">
      {{ help }}
    </div>
    <!-- <ul 
        class="parsley-errors-list filled" 
        v-if="error"
      >
      <li>
          <div v-if="!required">This value is required.</div>
          <div v-if="!email">This value should be a valid email.</div>
      </li>
    </ul> -->
  </div>
</template>

<script>
export default {
  props:['type', 'placeholder', 'label', 'icon', 'name', 'autocomplete', 'value', 'required', 'error', 'errorMessage', 'help', 'max', 'readonly', 'disabled'],
  data () {
    return {
      isBlur: false
    }
  },
  methods:{
    onBlur(){
      this.isBlur = false
      let val = parseFloat(this.$props.value)
      if(this.$props.max){
        if(val > this.$props.max){
          this.$props.value = this.$props.max
        }
      }
      // if(this.value) {
      //   this.isBlur = true
      // }
    }
  }
}
</script>
<style>
  input:is-valid {
    border:#2dc28c;
    content: "✓";
  }
</style>